// Pure decision logic for the KPI strip's on-demand totals fetch, kept free
// of store and network imports so it is unit-testable in isolation.
//
// The strip's selected year is independent of the trend range, but the main
// totals request only covers the range years. This resolves which years a
// follow-up fetch must load. The baseline year needs no handling here: the
// API includes it in every totals response unconditionally.
export const resolveMissingKpiYears = ({
  selectedYear,
  hasLoadedOnce,
  loadedYears = [],
  pendingYears = [],
  upcomingYears = [],
}) => {
  // The first range response defines the filter context (and the baseline);
  // fetching before it would race the context key.
  if (!hasLoadedOnce) return [];

  // Explicit None (null / "") must not coerce to year 0 via Number(null),
  // and booleans must not coerce to 0/1. Only numbers and numeric strings
  // are legitimate select values; the API validates integer years.
  if (typeof selectedYear !== "number" && typeof selectedYear !== "string") {
    return [];
  }
  if (selectedYear === "") return [];
  const year = Number(selectedYear);
  if (!Number.isInteger(year)) return [];

  const isYear = (candidate) => Number(candidate) === year;
  if (loadedYears.some(isYear) || pendingYears.some(isYear)) return [];
  // Covered by the range request that is being (or about to be) issued for
  // the current trend range: the range response will carry this year, so a
  // separate fetch would only duplicate it.
  if (upcomingYears.some(isYear)) return [];

  return [year];
};
